var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotepad(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 1.24997C16.9142 1.24997 17.25 1.58576 17.25 1.99997V2.74997H18C20.0711 2.74997 21.75 4.42892 21.75 6.49997V18.5C21.75 20.571 20.0711 22.25 18 22.25H6C3.92893 22.25 2.25 20.571 2.25 18.5V6.49997C2.25001 4.42892 3.92894 2.74997 6 2.74997H6.75V1.99997C6.75 1.58576 7.08579 1.24997 7.5 1.24997C7.91421 1.24997 8.25 1.58576 8.25 1.99997V2.74997H15.75V1.99997C15.75 1.58576 16.0858 1.24997 16.5 1.24997ZM3.75 18.5C3.75 19.7426 4.75736 20.75 6 20.75H18C19.2426 20.75 20.25 19.7426 20.25 18.5V9.24997H3.75V18.5ZM6 4.24997C4.75737 4.24997 3.75001 5.25735 3.75 6.49997V7.74997H20.25V6.49997C20.25 5.25735 19.2426 4.24997 18 4.24997H17.25V4.99997C17.25 5.41419 16.9142 5.74997 16.5 5.74997C16.0858 5.74997 15.75 5.41419 15.75 4.99997V4.24997H8.25V4.99997C8.25 5.41419 7.91421 5.74997 7.5 5.74997C7.08579 5.74997 6.75 5.41419 6.75 4.99997V4.24997H6Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotepad);
export default __webpack_public_path__ + "static/media/notepad.f0e4e475a1fee6841a3a287572f86bab.svg";
export { ForwardRef as ReactComponent };